<template>
  <div class="car-offer">
    <div class="car-offer__container">
      <div class="car-offer__title">What We Offer</div>

      <div class="car-offer__items">
        <div class="car-offer__item">
          <div class="car-offer__icon-wrapper">
            <img src="@/assets/categorized.png" class="car-offer__icon" alt="">
          </div>
          <div class="car-offer__item-title">Categorized Viewing</div>
          <div class="car-offer__item-desc">Browse by brand, model,
            and price.</div>
        </div>

        <div class="car-offer__item">
          <div class="car-offer__icon-wrapper">
            <img src="@/assets/analysis.png" class="car-offer__icon" alt="">
          </div>
          <div class="car-offer__item-title">Multidimensional Analysis</div>
          <div class="car-offer__item-desc">Detailed insights on
            performance and safety.</div>
        </div>

        <div class="car-offer__item">
          <div class="car-offer__icon-wrapper">
            <img src="@/assets/ratings.png" class="car-offer__icon" alt="">
          </div>
          <div class="car-offer__item-title">Comprehensive Ratings</div>
          <div class="car-offer__item-desc">Expert and user-based scores.</div>
        </div>

        <div class="car-offer__item">
          <div class="car-offer__icon-wrapper">
            <img src="@/assets/vehicle-info.png" class="car-offer__icon" alt="">
          </div>
          <div class="car-offer__item-title">Latest Vehicle Info</div>
          <div class="car-offer__item-desc">Up-to-date market releases.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CarOffer',
  computed: {
    ...mapGetters({
      deviceType: 'deviceType'
    })
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.car-offer {
	background: #ffffff;
	padding: rem(50) rem(120);

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	align-self: stretch;
	position: relative;

	&__container {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: rem(20);
	}

	&__title {
		color: #050b20;
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 900;
	}

	&__items {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		width: 100%;
		gap: rem(30);
	}

	&__item {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		gap: rem(16);
		flex: 1;
		background: #f9fbfc;
		padding: rem(30);
		border-radius: rem(12);
		transition: all 0.3s ease;

		&:hover {
			transform: translateY(-5px);
			box-shadow: 0 rem(10) rem(20) rgba(0, 0, 0, 0.05);
		}
	}

	&__icon-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		width: rem(60);
		height: rem(60);
	}

	&__icon {
		width: rem(60);
		height: rem(60);
		margin-bottom: rem(8);
	}

	&__item-title {
		color: #050b20;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 700;
	}

	&__item-desc {
		color: #050b20;
		font-weight: 400;

		font-size: rem(12);
		line-height: rem(16);
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.car-offer {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.car-offer {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);
		padding: rem(30) rem(16);

		&__items {
			flex-direction: column;
		}

		&__item {
			width: 100%;
			padding: rem(20);
		}
	}
}
</style> 